import { useDrop } from 'react-dnd';
import cx from 'classnames';
import BothHalvesCell from './BothHalvesCell';
import FirstHalfCell from './FirstHalfCell';
import SecondHalfCell from './SecondHalfCell';

const MasterScheduleCell = ({
  cell,
  getScheduleData,
  scheduleData,
  selectedUser,
  selectedCells,
  formData,
  sidebarAction,
  selectedAssignmentsToDelete,
  showNames,
}) => {
  const [, drop] = useDrop(
    () => ({
      accept: ['master_schedule_both_halves_assignment'],
      canDrop: () => !selectedUser,
      drop: () => ({ cell }),
    }),
    [selectedUser, cell],
  );

  return (
    <>
      {!cell.both_halves_user && !cell.first_half_user && !cell.second_half_user && !selectedUser && (
        <div ref={drop} className="empty-cell" style={{ width: '100%', height: '100%' }}></div>
      )}
      {cell.both_halves_user || (formData.halfPart?.value === 'both_halves' && selectedCells.find((item) => item.id === cell.id)) ? (
        <BothHalvesCell
          cell={cell}
          scheduleData={scheduleData}
          getScheduleData={getScheduleData}
          formData={formData}
          selectedUser={selectedUser}
          selectedCells={selectedCells}
          sidebarAction={sidebarAction}
          selectedAssignmentsToDelete={selectedAssignmentsToDelete}
          showNames={showNames}
        />
      ) : (
        <></>
      )}
      {cell.first_half_user ||
      cell.second_half_user ||
      ((formData.halfPart?.value === 'first_half' || formData.halfPart?.value === 'second_half') &&
        selectedCells.find((item) => item.id === cell.id)) ? (
        <div className="halves-recurring-shift-wrapper">
          <FirstHalfCell
            cell={cell}
            scheduleData={scheduleData}
            formData={formData}
            getScheduleData={getScheduleData}
            selectedUser={selectedUser}
            selectedCells={selectedCells}
            sidebarAction={sidebarAction}
            selectedAssignmentsToDelete={selectedAssignmentsToDelete}
            showNames={showNames}
          />
          <SecondHalfCell
            cell={cell}
            scheduleData={scheduleData}
            getScheduleData={getScheduleData}
            formData={formData}
            selectedUser={selectedUser}
            selectedCells={selectedCells}
            sidebarAction={sidebarAction}
            selectedAssignmentsToDelete={selectedAssignmentsToDelete}
            showNames={showNames}
          />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default MasterScheduleCell;
